
<footer class="footer">
  <div class="footer--container">
    <div class="footer--content">
      <!-- About Section -->
      <div class="footer--section footer--about">
        <h3 class="footer--title">National Health Authority</h3>
        <p class="footer--description">
          The National Health Authority (NHA) leads implementation of the Ayushman Bharat Digital Mission and related programmes to strengthen India’s digital health infrastructure.
        </p>

        <div class="footer--contact">
          <div class="contact--item">
            <img [src]="globalIcon" alt="Website" class="contact--icon" />
            <a [href]="publicWebsiteUrl" target="_blank" rel="noopener noreferrer">{{ publicWebsiteUrl }}</a>
          </div>
        </div>
      </div>

      <!-- Important Links -->
      <div class="footer--section footer--links">
        <h3 class="footer--section-title">Important links</h3>
        <ul class="footer--link-list">
          <li *ngFor="let link of importantLinks">
            <a 
              *ngIf="!link.external && link.label !== 'Dashboard' && link.url" 
              [routerLink]="link.url" 
              class="footer--link">{{ link.label }}</a>
            <a 
              *ngIf="!link.external && link.label === 'Dashboard'" 
              href="#"
              (click)="onDashboardClick($event)"
              class="footer--link">{{ link.label }}</a>
            <a *ngIf="link.external" [href]="link.url" target="_blank" rel="noopener noreferrer" class="footer--link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Developer Links -->
      <div class="footer--section footer--developers">
        <h3 class="footer--section-title">For Developers</h3>
        <ul class="footer--link-list">
          <li *ngFor="let link of developerLinks">
            <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="footer--link">{{ link.label }}</a>
          </li>
        </ul>
        <a href="#" (click)="onContactUsClick($event)" class="footer--contact-btn">Contact us</a>
      </div>

      <!-- Social Media -->
      <div class="footer--section footer--social-column">
        <h3 class="footer--section-title">Social Media</h3>
        <ul class="footer--social-list">
          <li *ngFor="let social of socialLinks" class="footer--social-item">
            <a
              [href]="social.url"
              class="footer--social-anchor"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="social.label"
            >
              <img [src]="social.iconSrc" alt="" width="24" height="24" class="footer--social-icon" />
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Copyright -->
    <div class="footer--bottom">
      <p class="footer--copyright">
        © {{ currentYear }} by NHA
        <span class="footer--legal-links">
          <a [routerLink]="['/privacy-policy']" class="footer--legal-link">Privacy Policy</a>
          <span class="footer--separator">|</span>
          <a [routerLink]="['/terms-of-service']" class="footer--legal-link">Terms of Service</a>
        </span>
      </p>
    </div>
  </div>
</footer>

<app-login-modal
  *ngIf="showLoginModal"
  [redirectUri]="contactUsRedirectUri"
  (visibleChange)="showLoginModal = $event"
></app-login-modal>


